import { theme } from 'antd';
import { MAIN_DASHBOARD_ROUTES } from 'navigation/routes';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, matchPath, useLocation } from 'react-router-dom';
import { appActions } from 'reduxStore/app/slice';
import styled from 'styled-components';
import { Breadcrumb } from 'zui/Antd';

const HOME_ROUTE = '/access/';
const ACCESS_HOME_ROUTE = '/access';

const StyledLink = styled(Link)`
	&:hover {
		color: ${({ color }) => color} !important;
	}
`;

const TopBarBreadcrumb = () => {
	const {
		token: { fontSize, colorTextDescription, marginXXS }
	} = theme.useToken();

	const location = useLocation();
	const dispatch = useDispatch();
	const [breadcrumbs, setBreadcrumbs] = useState([]); // State to store breadcrumb items

	// Function to generate breadcrumbs based on the current path
	const generateBreadcrumbs = (currentPath) => {
		const trimmedPath = currentPath.replace(HOME_ROUTE, ''); // Remove the base route from the path

		// Find the first matching route from our predefined routes
		let matchedRoute = MAIN_DASHBOARD_ROUTES.find((route) =>
			matchPath({ path: `/${route.path}`, caseSensitive: false, end: true }, `/${trimmedPath}`)
		);

		if (trimmedPath === ACCESS_HOME_ROUTE) {
			matchedRoute = {
				key: `home-${breadcrumbs.length}`, // Unique key for Home breadcrumb
				path: '', // Home path
				name: 'Home' // Home display name
			};
		}
		// If no matching route found, return the existing breadcrumbs
		if (!matchedRoute) return breadcrumbs;

		// Check if the matched route is already in the breadcrumbs
		const existingIndex = breadcrumbs.findIndex((breadcrumb) => breadcrumb.name === matchedRoute.name);
		let updatedBreadcrumbs = [...breadcrumbs];

		if (existingIndex !== -1) {
			// If the breadcrumb is already in the list, reorder it to the end
			updatedBreadcrumbs = [
				...updatedBreadcrumbs.slice(0, existingIndex),
				...updatedBreadcrumbs.slice(existingIndex + 1),
				matchedRoute
			];
		} else {
			// Add the new breadcrumb at the end if it isn't already present
			updatedBreadcrumbs = [...updatedBreadcrumbs, matchedRoute];
		}

		// Limit breadcrumbs to the latest 3 items
		if (updatedBreadcrumbs.length > 3) {
			updatedBreadcrumbs = updatedBreadcrumbs.slice(-3);
		}

		setBreadcrumbs(updatedBreadcrumbs); // Update state with the new list
		return updatedBreadcrumbs;
	};

	// Preserve breadcrumbs on each page navigation and keep track of each movement
	useEffect(() => {
		setBreadcrumbs((prevBreadcrumbs) => generateBreadcrumbs(location.pathname));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location.pathname]);

	return (
		<Breadcrumb
			separator='/'
			style={{
				fontSize: fontSize,
				lineHeight: '22px',
				marginLeft: marginXXS
			}}
			items={breadcrumbs}
			itemRender={(route, _, routes) => {
				return (
					<StyledLink
						key={route.path}
						onClick={() => dispatch(appActions.changeCurrent([route.path]))}
						to={route.path === '' ? ACCESS_HOME_ROUTE : `${HOME_ROUTE}${route.path}`}
						color={colorTextDescription}
					>
						{route.name}
					</StyledLink>
				);
			}}
		/>
	);
};

export default TopBarBreadcrumb;
